(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    (function() {
    var button = document.querySelector('[data-back-to-top]');
    if (!button) return;

    function onScroll() {
      button.hidden = window.scrollY < 460;
    }

    button.addEventListener('click', function() {
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    });

    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["faceted-filters"] && !Shopify.designMode) return;
  try {
    (function() {
    document.addEventListener('change', function(e) {
      var checkbox = e.target.closest('[data-filter-checkbox]');
      if (checkbox) {
        var form = checkbox.closest('[data-faceted-form]');
        if (form) {
          form.submit();
        }
        return;
      }
    });

    /* Debounced submit for price range inputs */
    var priceTimer = null;
    document.addEventListener('input', function(e) {
      var priceInput = e.target.closest('[data-filter-price]');
      if (!priceInput) return;

      clearTimeout(priceTimer);
      priceTimer = setTimeout(function() {
        var form = priceInput.closest('[data-faceted-form]');
        if (form) {
          form.submit();
        }
      }, 800);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll('[data-predictive-search]').forEach(function(root) {
      var input = root.querySelector('[data-predictive-input]');
      var results = root.querySelector('[data-predictive-results]');
      if (!input || !results) return;
      var noResultsLabel = root.getAttribute('data-no-results-label') || 'No results';
      var errorLabel = root.getAttribute('data-error-label') || 'Search is temporarily unavailable';
      var productLabel = root.getAttribute('data-product-label') || 'Product';
      var articleLabel = root.getAttribute('data-article-label') || 'Article';
      var pageLabel = root.getAttribute('data-page-label') || 'Page';

      var controller;

      function renderEmpty() {
        results.innerHTML = '<p class="predictive-search__empty">' + noResultsLabel + '</p>';
        results.hidden = false;
      }

      function renderError() {
        results.innerHTML = '<p class="predictive-search__empty">' + errorLabel + '</p>';
        results.hidden = false;
      }

      function renderItems(items) {
        if (!items.length) {
          renderEmpty();
          return;
        }

        var html = '<ul class="predictive-search__list" role="list">';
        items.slice(0, 7).forEach(function(item) {
          html += '<li class="predictive-search__item">';
          html += '<a href="' + item.url + '">';
          html += '<span class="predictive-search__title">' + item.title + '</span>';
          html += '<span class="predictive-search__type">' + item.type + '</span>';
          html += '</a></li>';
        });
        html += '</ul>';

        results.innerHTML = html;
        results.hidden = false;
      }

      function parseItems(data) {
        var resources = (data.resources && data.resources.results) || {};
        var items = [];

        (resources.products || []).forEach(function(p) {
          items.push({ title: p.title, url: p.url || '#', type: productLabel });
        });
        (resources.articles || []).forEach(function(a) {
          items.push({ title: a.title, url: a.url || '#', type: articleLabel });
        });
        (resources.pages || []).forEach(function(pg) {
          items.push({ title: pg.title, url: pg.url || '#', type: pageLabel });
        });

        return items;
      }

      function fetchPredictive(term) {
        if (!term || term.length < 2) {
          results.hidden = true;
          results.innerHTML = '';
          return;
        }

        if (controller) controller.abort();
        controller = new AbortController();

        var query = 'q=' + encodeURIComponent(term) + '&resources[type]=product,page,article&resources[limit]=4';
        var endpoint = root.getAttribute('data-predictive-url');

        fetch(endpoint + '?' + query, { signal: controller.signal })
          .then(function(res) {
            if (!res.ok) throw new Error('predictive-search-request-failed');
            return res.json();
          })
          .then(function(data) {
            renderItems(parseItems(data));
          })
          .catch(function(error) {
            if (error.name === 'AbortError') return;
            renderError();
          });
      }

      input.addEventListener('input', function() {
        fetchPredictive(input.value.trim());
      });

      document.addEventListener('click', function(event) {
        if (!root.contains(event.target)) {
          results.hidden = true;
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.__petsSOUKQuickAddInit) return;
    window.__petsSOUKQuickAddInit = true;

    function updateCartCount(count) {
      var toggles = document.querySelectorAll('[data-cart-toggle]');
      toggles.forEach(function(toggle) {
        var badge = toggle.querySelector('.header__cart-count');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'header__cart-count';
            toggle.appendChild(badge);
          }
          badge.textContent = String(count);
        } else if (badge) {
          badge.remove();
        }
      });
    }

    function refreshCartState() {
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      fetch(rootPath + 'cart.js')
        .then(function(res) { return res.ok ? res.json() : null; })
        .then(function(cart) {
          if (!cart) return;
          updateCartCount(cart.item_count || 0);
        })
        .catch(function() {});
    }

    document.addEventListener('click', function(event) {
      var stepper = event.target.closest('[data-quick-add-step]');
      if (stepper) {
        var qtyWrap = stepper.closest('[data-quick-add-qty-wrap]');
        if (!qtyWrap) return;
        var qtyInput = qtyWrap.querySelector('[data-quick-add-qty]');
        if (!qtyInput) return;
        var step = parseInt(stepper.getAttribute('data-quick-add-step'), 10) || 0;
        var current = parseInt(qtyInput.value, 10);
        if (!Number.isFinite(current) || current < 1) current = 1;
        qtyInput.value = Math.max(1, current + step);
        return;
      }

      var optionBtn = event.target.closest('[data-variant-option]');
      if (!optionBtn) return;
      var form = optionBtn.closest('[data-quick-add-form]');
      if (!form) return;
      var variantInput = form.querySelector('[data-quick-add-variant]');
      var submit = form.querySelector('[data-quick-add-submit]');
      if (!variantInput || !submit) return;

      form.querySelectorAll('[data-variant-option]').forEach(function(btn) {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
      });

      optionBtn.classList.add('is-active');
      optionBtn.setAttribute('aria-pressed', 'true');
      variantInput.value = optionBtn.getAttribute('data-variant-id') || '';

      var isAvailable = optionBtn.getAttribute('data-variant-available') === 'true';
      submit.disabled = !isAvailable;
      submit.textContent = isAvailable ? (submit.getAttribute('data-label-default') || '') : (submit.getAttribute('data-label-unavailable') || '');
    });

    document.addEventListener('submit', function(event) {
      var form = event.target.closest('[data-quick-add-form]');
      if (!form) return;
      event.preventDefault();

      var submit = form.querySelector('[data-quick-add-submit]');
      if (!submit || submit.disabled) return;

      var defaultLabel = submit.getAttribute('data-label-default') || submit.textContent;
      var addingLabel = submit.getAttribute('data-label-adding') || defaultLabel;
      var addedLabel = submit.getAttribute('data-label-added') || defaultLabel;
      var unavailableLabel = submit.getAttribute('data-label-unavailable') || defaultLabel;

      var formData = new FormData(form);
      var endpoint = form.getAttribute('action') || '/cart/add';
      if (!endpoint.endsWith('.js')) endpoint += '.js';

      submit.classList.add('is-loading');
      submit.textContent = addingLabel;

      fetch(endpoint, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
        .then(function(res) {
          if (!res.ok) throw new Error('add_failed');
          return res.json();
        })
        .then(function(item) {
          submit.textContent = addedLabel;
          refreshCartState();
          // Dispatch cart:updated event to trigger drawer refresh
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { openDrawer: true, item: item },
            bubbles: true
          }));
          window.setTimeout(function() {
            submit.textContent = defaultLabel;
          }, 1300);
        })
        .catch(function() {
          submit.textContent = unavailableLabel;
          submit.disabled = true;
        })
        .finally(function() {
          submit.classList.remove('is-loading');
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(e) {
    var minusBtn = e.target.closest('[data-quantity-minus]');
    var plusBtn = e.target.closest('[data-quantity-plus]');
    if (!minusBtn && !plusBtn) return;

    var container = (minusBtn || plusBtn).closest('.quantity-selector');
    var input = container.querySelector('.quantity-selector__input');
    var currentVal = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 99;

    if (minusBtn && currentVal > min) {
      input.value = currentVal - 1;
    } else if (plusBtn && currentVal < max) {
      input.value = currentVal + 1;
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["share-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-copy-url]');
    if (!btn) return;
    var url = btn.getAttribute('data-copy-url');
    navigator.clipboard.writeText(url);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["swatch-selector"] && !Shopify.designMode) return;
  try {
    (function() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-swatch-value]');
      if (!btn) return;

      var container = btn.closest('[data-swatch-selector]');
      if (!container) return;

      var value = btn.getAttribute('data-swatch-value');
      var hiddenSelect = container.querySelector('[data-product-option]');

      /* Update active state on buttons */
      container.querySelectorAll('[data-swatch-value]').forEach(function(b) {
        var isActive = b === btn;
        b.classList.toggle('swatch-selector__btn--active', isActive);
        b.setAttribute('aria-pressed', String(isActive));
        b.setAttribute('aria-checked', String(isActive));
      });

      /* Sync hidden select and trigger change for variant JS */
      if (hiddenSelect) {
        hiddenSelect.value = value;
        hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
